import React from 'react';

const SVG = ({
  fill = '#fff',
  width = '100%',
  height = '100%',
  className = 'designSVG',
}) => (
  <svg
    viewBox="0 0 288 267.5"
    height={height}
    width={width}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M268.5,223.7L174.6,58.4l-13.9,22c7.1,11.6,11.2,25.1,11.2,39.6c0,42.1-34.1,76.2-76.2,76.2c-2.6,0-5.3-0.1-7.8-0.4
		l-17.6,27.9L268.5,223.7z"
      />
      <path d="M95.7,43.8c-42.1,0-76.2,34.1-76.2,76.2c0,39.4,30,71.9,68.4,75.8l72.8-115.4C147.3,58.5,123.2,43.8,95.7,43.8z" />
    </g>
  </svg>
);

export default SVG;
